(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wwlw-size-guide"] && !Shopify.designMode) return;
  try {
    const sizeGuideRoot = document.querySelector('[data-wwlw-size-guide]');

    if (sizeGuideRoot && !sizeGuideRoot.dataset.initialized) {
      sizeGuideRoot.dataset.initialized = 'true';
      const dialog = sizeGuideRoot.querySelector('dialog');
      const closeButton = sizeGuideRoot.querySelector('.wwlw-size-guide__close');

      const addTrigger = () => {
        const sizeLegend = [...document.querySelectorAll('variant-picker fieldset legend')].find(
          (legend) => legend.textContent.trim().toLowerCase().startsWith('size')
        );

        if (!sizeLegend || sizeLegend.querySelector('.wwlw-size-guide__trigger')) return;

        const trigger = document.createElement('button');
        trigger.type = 'button';
        trigger.className = 'wwlw-size-guide__trigger';
        trigger.textContent = sizeGuideRoot.dataset.triggerLabel;
        trigger.addEventListener('click', () => dialog.showModal());
        sizeLegend.append(trigger);
      };

      addTrigger();
      new MutationObserver(addTrigger).observe(document.body, { childList: true, subtree: true });

      closeButton.addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => {
        if (event.target === dialog) dialog.close();
      });
    }
  } catch(e) { console.error(e); }
})();

})();
